<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        :rules="rules"
        ref="ruleForm"
      >
        <a-form-model-item label="Group / Nhóm" prop="groupId">
          <SelectHelpdeskGroup
            v-model="form.groupId"
            :initial-datas="form.group ? [form.group] : null"
            :select-props="{ placeholder: 'Choose group', value: form.groupId }"
          />
        </a-form-model-item>
        <a-form-model-item label="Code / Mã" prop="code">
          <a-input v-model="form.code" placeholder="Enter text" />
        </a-form-model-item>
        <a-form-model-item label="Title / Danh mục" prop="title">
          <a-input v-model="form.title" placeholder="Enter text..." />
        </a-form-model-item>
        <a-form-model-item label="Description / Mô tả">
          <VueEditor
            class="ict24h-editor"
            :editor-toolbar="customToolbar"
            placeholder="Enter text..."
            v-model="form.description"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="Process users">
          <SelectUser
            :selectProps="{
              placeholder: 'Choose users',
              mode: 'multiple',
              value: form.processUserIds,
            }"
            v-model="form.processUserIds"
            :initialDatas="form.processUsers"
            :variablesQuery="{ hasEmployee: undefined }"
          />
        </a-form-model-item> -->
      </a-form-model>
      <div style="margin-top: 20px;">
        <div class="ant-descriptions-title" style="margin-bottom: 10px;">
          <a-icon type="user" /> Process User
        </div>
        <ProcessUsers
          :categoryId="idHelpdesk"
          :setProcessUsers="
            (array) => {
              processUsers = [...array];
            }
          "
          :setLoadingProcessUser="setLoadingProcessUser"
        />
      </div>

      <div style="margin-top: 20px;">
        <span class="ant-descriptions-title">
          QA / Hỗ trợ tham khảo ({{ form.qas && form.qas.length }})
          <a-button
            @click="visibleQA = true"
            style="float: right;"
            type="link"
            icon="plus"
          >
            ADD
          </a-button>
        </span>
      </div>

      <a-divider orientation="left">
        INFORMATION / THÔNG TIN CẬP NHẬT
      </a-divider>
      <a-descriptions :column="1">
        <a-descriptions-item label="Created by">
          {{ form.author && (form.author.fullname || form.author.username) }}
        </a-descriptions-item>
        <a-descriptions-item label="Created at">
          {{ form.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Updated at">
          {{ form.updatedAt | formatDateHour }}
        </a-descriptions-item>
      </a-descriptions>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Confirm action?"
          ok-text="Delete"
          cancel-text="No"
          @confirm="onDeletedHelpdesk"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left; margin-right: 10px;"
            :loading="loadingProcessUser"
          >
            Delete
          </a-button>
        </a-popconfirm>
        <a-popconfirm
          ok-text="Copy"
          cancel-text="No"
          @confirm="copyItem"
          :disabled="loadingProcessUser"
        >
          <span slot="title">
            {{
              processUsers.length > 0
                ? "Do you want copy this item?"
                : "Process users is empty, Are you sure copy this item?"
            }}
          </span>
          <a-button
            icon="copy"
            style="float: left;"
            type="dashed"
            :loading="loadingBtn"
            :disabled="loading"
          >
            Copy
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" @click="close">
          Close
        </a-button>
        <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
          Update
        </a-button>
      </div>
      <a-drawer
        title="QA / Câu hỏi hỗ trợ"
        placement="right"
        :visible="visibleQA"
        @close="() => (visibleQA = false)"
        :width="500"
        :bodyStyle="{ height: 'auto', overflowY: 'auto' }"
      >
        <QASHelpdesk
          :refreshAfterCreatedQA="refreshAfterCreatedQA"
          :refreshAfterDeletedQA="refreshAfterDeletedQA"
          :refreshAfterUpdatedQA="refreshAfterUpdatedQA"
          :idHelpdesk="idHelpdesk"
          :qas="form.qas"
        />
      </a-drawer>
    </div>
  </a-skeleton>
</template>
<script>
import query from "../constant/query";
import queryProcessUser from "./processUsers/query.define";
import SelectHelpdeskGroup from "@/components/common/helpdeskGroup/select";
import QASHelpdesk from "./qasHeldesk";
import ProcessUsers from "./processUsers/table.vue";
import {
  updateForUpdated,
  updateForDeleted,
  updateForCreated,
} from "@/services/updateOnViewConfig";

export default {
  components: { QASHelpdesk, ProcessUsers, SelectHelpdeskGroup },
  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
    idHelpdesk: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      rules: {
        groupId: [
          {
            required: true,
            message: "Required / Thông tin không được bỏ trống",
          },
        ],
        title: [
          {
            required: true,
            message: "Required / Thông tin không được bỏ trống",
          },
        ],
        code: [
          {
            required: true,
            message: "Required / Thông tin không được bỏ trống",
          },
          {
            validator: (rule, value, callback) => {
              const regCode = /^\w{4,100}$/;
              if (!regCode.test(value)) {
                callback(
                  new Error(
                    "Mã yêu cầu tối thiểu 4 ký tự, không được trùng, không dấu cách, không dấu,ký tự đặc biệt trừ dấu _"
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
      loadingBtn: false,
      visibleQA: false,
      loadingProcessUser: false,
      processUsers: [],
    };
  },
  created() {
    this.onGetHelpdesk();
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdatedHelpdesk();
        } else {
          return false;
        }
      });
    },
    async copyItem() {
      this.loadingBtn = true;
      const cloneItem = { ...this.form, code: this.form.code + "_COPY" };

      try {
        const newHelpdesk = await this.onCreatedHelpdesk(cloneItem);
        if (this.processUsers?.length > 0) {
          console.log("this.processUsers", this.processUsers);
          for (let i in this.processUsers) {
            await this.createProcessUser(newHelpdesk, this.processUsers[i]);
          }
        }

        this.$notification.success({
          message: "Success",
          description: "Create success!",
        });
        this.loadingBtn = false;
        this.close();
      } catch (err) {
        this.$notification.error({
          message: "Error",
          description: "Create error!",
        });
        console.error("Thêm danh mục hỗ trợ không thành công", err);
      }
    },
    onUpdatedHelpdesk() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateHelpdeskCategory,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Cập nhật danh mục hỗ trợ thành công!",
          });
          this.loadingBtn = false;
          if (data?.updateHelpdeskCategory?.id) {
            this.refreshAfterUpdated(data.updateHelpdeskCategory);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Cập nhật danh mục hỗ trợ không thành công!",
          });
          console.log("Cập nhật danh mục hỗ trợ không thành công", err);
        });
    },
    onGetHelpdesk() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getDetailHelpdeskCategory,
          variables: { id: this.idHelpdesk },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getDetailHelpdeskCategory?.id) {
            let processUserIds = [];
            if (data.getDetailHelpdeskCategory?.processUsers?.length > 0) {
              processUserIds = data.getDetailHelpdeskCategory.processUsers.map(
                (e) => e.id
              );
            }
            this.form = { ...data.getDetailHelpdeskCategory, processUserIds };
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Lấy chi tiết danh mục hỗ trợ không thành công!",
          });
          console.log("Lấy chi tiết danh mục hỗ trợ không thành công", err);
        });
    },
    onDeletedHelpdesk() {
      if (this?.form?.id) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteHelpdeskCategory,
            variables: {
              id: this.form.id,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Thông báo",
              description: "Xóa danh mục hỗ trợ thành công!",
            });
            this.loadingBtn = false;
            if (data?.deleteHelpdeskCategory?.id) {
              this.refreshAfterDeleted(data.deleteHelpdeskCategory);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Thông báo",
              description: "Xóa danh mục hỗ trợ không thành công!",
            });
            console.log("Xóa danh mục hỗ trợ không thành công", err);
          });
      }
    },
    onCreatedHelpdesk(item) {
      return this.$apollo
        .mutate({
          mutation: query.createHelpdeskCategory,
          variables: {
            ...item,
          },
        })
        .then(({ data }) => {
          if (data?.createHelpdeskCategory?.id) {
            this.refreshAfterCreated(data.createHelpdeskCategory);
          }
          return data?.createHelpdeskCategory?.id
            ? { ...data.createHelpdeskCategory }
            : {};
        });
    },
    refreshAfterCreatedQA(qa) {
      if (qa?.id && this.form?.qas?.length >= 0) {
        this.form.qas = updateForCreated({ list: this.form.qas, item: qa });
      }
    },
    refreshAfterUpdatedQA(qa) {
      if (qa?.id && this.form?.qas?.length > 0) {
        this.form.qas = updateForUpdated(this.form.qas, qa);
      }
    },
    refreshAfterDeletedQA(qa) {
      if (qa?.id && this.form?.qas?.length > 0) {
        this.form.qas = updateForDeleted(this.form.qas, qa);
      }
    },
    async createProcessUser(helpdesk = {}, processUser = {}) {
      try {
        await this.$apollo.mutate({
          mutation: queryProcessUser.createHelpdeskProcessUser,
          variables: {
            branchLocationId: processUser.branchLocationId || null,
            processUserIds:
              processUser.processUsers?.length > 0
                ? processUser.processUsers.map((e) => e.id)
                : null,
            categoryId: helpdesk.id,
          },
        });
      } catch (err) {
        console.error("err", err);
        this.$notification.error({
          message: "Error",
          description: "Create error!",
        });
      }
    },
    setLoadingProcessUser(bool) {
      this.loadingProcessUser = bool;
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
